import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OptionSelect, SelectComponent} from "../select/select.component";
import {FormControl} from "@angular/forms";

@Component({
  selector: 'tgt-select-color',
  standalone: true,
  imports: [
    SelectComponent
  ],
  templateUrl: './select-color.component.html',
  styleUrl: './select-color.component.scss'
})
export class SelectColorComponent {

  @Input() label: string = '';
  @Input() options: OptionSelect[] = [];
  @Input() valueOptionSelected: OptionSelect = {label: 'Verde', value: 'green'};
  @Input() control: FormControl = new FormControl();
  @Input() icon: string = 'arrow_drop_down';
  @Input() size: 'small' | 'middle' = 'middle';
  @Input() border: boolean = true;
  @Input() background: string = '';
  @Input() borderRadios: boolean = false;
  @Input() error: boolean = false;
  @Output() changeValue = new EventEmitter();
  @Output() changeOption = new EventEmitter<OptionSelect>();

  optionsColor: OptionSelect[] = [
    {label: 'Verde', value: 'green'},
    {label: 'Vermelho', value: 'red'},
    {label: 'Azul', value: 'blue'},
    {label: 'Amarelo', value: 'yellow'},
    {label: 'Rosa', value: 'pink'},
    {label: 'Roxo', value: 'purple'},
    {label: 'Laranja', value: 'orange'},
  ]

  optionSelect(option: OptionSelect) {
    this.valueOptionSelected = option;
    this.control.setValue(option.value);
    this.changeValue.emit(this.control.value);
    this.changeOption.emit(option);
  }
}
